import appConfig from '../config'

export const isApacRegion = appConfig.region === 'APAC'
export const isGeminiRegion = appConfig.region === 'GEMINI'
